import React from "react";
import styles from "./ABOGrowthCompanion.module.scss";
import LegAnalysis from "./LegAnalysis/LegAnalysis";
import BusinessPerformance from "./BusinessPerformance/BusinessPerformance";
import Qualifications from "./Qualifications/Qualifications";
import Income from "./Income/Income";
import { useProfileParams } from "../../../utils/common";
import Pipeline from "./Pipeline/Pipeline";
import IncomeQualification from "./Income&Qualification/IncomeQualification";
import Portfolio from "./Portfolio/Portfolio";

interface ABOGrowthCompanionProps {}

const ABOGrowthCompanion: React.FC<ABOGrowthCompanionProps> = () => {
  const { aboNumber } = useProfileParams();

  return (
    <div
      className={styles.abo_growth_companion_wrapper}
      data-testid="business_information_plan_testID"
    >
      <div
        className={`content_inner ${styles.abo_growth_companion_inner_wrapper}`}
      >
        {/* <div className={styles.section_wrapper} ref={refMap["key_kpis"]}>
          <KeyKpis />
        </div> */}
        <div
          className={styles.section_wrapper}
        >
          <BusinessPerformance key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <Pipeline category="pipeline" key={aboNumber} />
        </div>
        {/* 
        TODO: Remove deprecated Pipeline component after confirming new Pipeline works as expected
        
        <div className={styles.section_wrapper}>
          <PipelineDepracated category="pipeline" key={aboNumber} />
        </div> */}
        {/*TODO: Remove deprecated Qualifications component after confirming new IncomeQualification works as expected*/}
        {/*<div className={styles.section_wrapper}>*/}
        {/*  <Qualifications category="qualifications" key={aboNumber} />*/}
        {/*</div>*/}
        <div className={styles.section_wrapper}>
          <LegAnalysis category="structure" key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <IncomeQualification key={aboNumber} />
        </div>
        <div className={styles.section_wrapper}>
          <Portfolio category="portfolio" key={aboNumber} />
        </div>
        {/*TODO: Remove deprecated Income component after confirming new IncomeQualification works as expected*/}
        {/*<div className={styles.section_wrapper}>*/}
        {/*  <Income category="income" key={aboNumber} />*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

export default ABOGrowthCompanion;
